import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  isOpen: boolean;
  isCollapsed: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  openSidebar: () => void;
  toggleCollapsed: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set, get) => ({
      isOpen: false,
      isCollapsed: false,

      toggleSidebar: () => {
        set(state => ({ isOpen: !state.isOpen }));
      },

      closeSidebar: () => {
        set({ isOpen: false });
      },

      openSidebar: () => {
        set({ isOpen: true });
      },

      toggleCollapsed: () => {
        set(state => ({ isCollapsed: !state.isCollapsed }));
      }
    }),
    {
      name: 'sidebar-storage',
      partialize: (state) => ({ isCollapsed: state.isCollapsed })
    }
  )
);